
$(document).on('click', '[data-category-filter-toggle]', function () {
  const $label = $(this);
  const $icons = $label.find('[data-category-filter-icon]');
  const $dropdown = $label.next('[data-category-filter-dropdown]');
  $dropdown.children().first().click();
  $icons.each((index, element) => {
    $(element).toggleClass('hide');
  });
  $dropdown.toggleClass('hide');
});

$(document).on('click', '[data-folded-filter-toggle]', function () {
  const url = new URL(window.location);
  const $label = $(this);
  const $targetFilterDropdown = $label.next();
  const $icon = $label.find('[data-folded-filter-icon]');
  $icon.toggleClass('icon-plus icon-minus');
  $targetFilterDropdown.toggleClass('hide');
  if ($targetFilterDropdown.hasClass('hide')) {
    url.searchParams.delete(`${$targetFilterDropdown.data('folded-filter')}`);
  } else {
    url.searchParams.set(`${$targetFilterDropdown.data('folded-filter')}`, '1');
  }
  window.history.pushState(null, '', url.toString());
});

const currentUrl = new URL(window.location);
// eslint-disable-next-line import/prefer-default-export
export const setFilterState = (url) => {
  const $activeFiltersDropdowns = [];
  url.searchParams.forEach((value, key) => {
    const $filterDropdown = $(`[data-folded-filter=${key}]`);
    if ($filterDropdown.length) {
      $activeFiltersDropdowns.push($filterDropdown);
    }
  });
  $activeFiltersDropdowns.forEach(($el) => {
    $el.prev().trigger('click');
  });
};
setFilterState(currentUrl);
